import { useEffect } from 'react';

const useCloseByKey = (closeHandler: () => void, key: string = 'Escape') => {
  const closeByKeyHandler = (e: KeyboardEvent) => {
    if (e.code === key) {
      closeHandler();
    }
  };

  useEffect(() => {
    document.addEventListener('keydown', closeByKeyHandler);
    return () => {
      document.removeEventListener('keydown', closeByKeyHandler);
    };
  }, []);
};

export default useCloseByKey;
